import { useCallback } from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';

export interface UseScrollToBottomHook {
  prepareToScrollToBottom: () => void;
  scrollToBottomIfNecessary: () => void;
}

export const useScrollToBottom = ({
  bottomOfTableDivRef,
}: {
  bottomOfTableDivRef: React.RefObject<HTMLElement>;
}): UseScrollToBottomHook => {
  const [scrollToBottomPending, setScrollToBottomPending] =
    useState<boolean>(false);
  const [scrollToBottomTrigger, setScrollToBottomTrigger] =
    useState<boolean>(false);

  useEffect(() => {
    if (scrollToBottomTrigger && scrollToBottomPending) {
      bottomOfTableDivRef.current?.scrollIntoView({
        behavior: 'smooth',
      });
    }
    setScrollToBottomPending(false);
  }, [
    scrollToBottomTrigger,
    scrollToBottomPending,
    setScrollToBottomPending,
    bottomOfTableDivRef,
  ]);

  const prepareToScrollToBottom = useCallback(() => {
    setScrollToBottomTrigger(false);
    setScrollToBottomPending(true);
  }, []);

  const scrollToBottomIfNecessary = useCallback(() => {
    setScrollToBottomTrigger(true);
  }, []);

  return useMemo(() => {
    return {
      prepareToScrollToBottom,
      scrollToBottomIfNecessary,
    };
  }, [prepareToScrollToBottom, scrollToBottomIfNecessary]);
};
